/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './player-root.html';

import LoaderRoot from '../core/loader/loader-root';
import ViewerPreviewRoot from '../core/viewer/preview/viewer-preview-root';
import ViewerStatefulRoot from '../core/viewer/stateful/viewer-stateful-root';
import { mixinType } from '../util.type';
import { $root } from './player';

export default defineComponent({
  name: 'PlayerRoot',
  template,
  components: {
    LoaderRoot,
    ViewerPreviewRoot,
    ViewerStatefulRoot
  },
  data() {
    return mixinType(
      {
        hasSupportedBrowser: $root(this).appManager.hasSupportedBrowser,
        stateful: $root(this).device.stateful
      },
      {}
    );
  },
  emits: {
    /**
     * @param {Error} error
     */
    // eslint-disable-next-line n/handle-callback-err
    error(error) {}
  },
  methods: {
    /**
     * @private
     * @param {Error} error
     */
    onError(error) {
      this.$emit('error', error);
    }
  },
  props: {}
});
